import React, { useReducer, useEffect } from "react";
import AutonomosCard, {
  Container,
  Description,
  Row,
  Title,
  Counter,
  Link,
  Price,
  TextList,
} from "@/components/autonomos/core/card";

const MainCard = (props) => {
  const {
    title,
    count = 0,
    selected,
    counter,
    price,
    link,
    maxWidth,
    minWidth,
    width,
    onLoad,
    characs,
    postPriceText,
    onUserAction,
    ...rest
  } = props;

  return (
    <AutonomosCard
      {...props}
      width={width}
      maxWidth={maxWidth}
      minWidth={minWidth}
      selected={selected}
      onUserAction={onUserAction}
      onLoad={onLoad}
      {...rest}
    >
      <Container>
        <Row>
          <Title size="t6" text={title?.text} {...title} />
        </Row>

        <TextList {...characs} />
        <Link href={link?.href} label={link?.label} />

        <Row horizontalAlign="end" gap="18px">
          {counter && <Counter value={count} />}
          <Row verticalAlign="end">
            <Row fullWidth={false} gap="6px">
              <Price size="xs" {...price} />
              <Description size="body1" {...postPriceText} />
            </Row>
          </Row>
        </Row>
      </Container>
    </AutonomosCard>
  );
};

export default MainCard;

MainCard.defaultProps = {
  defaultValue: 0,
};
